<template>
    <div class="">
        <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
            class="bigBox">
            <a-spin :spinning="spinning">
                <a-form :form="form" @submit="handleSubmit" :selfUpdate="true" v-bind="formItemLayoutWithOutLabel">
                    <div v-for="(k, index) in keysa" :key="k" style="position: relative;margin-bottom: 25px;border-bottom: 1px solid rgb(230 226 226);">
                        <div class="flex">
                            <a-form-item label="模 块" class="inputBox">
                                <a-select @change="(value)=>{changeTag(value,k)}"
                                          v-decorator="[ `tag-${k}`, {   rules: [ { required: true,  whitespace: true,  message: '模块不能为空', }, ],  }, ]">
                                    <a-select-option :value="item.tag" v-for="item in seleList.tagList" :key="item.tag">
                                        {{ item.tag }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item label="类 型" class="inputBox">
                                <!--{{form.getFieldValue(`type-${k}`)}}-->
                                <a-select @change="(value)=>{changeType(value,k)}"
                                    v-decorator="[ `type-${k}`, {   rules: [ { required: true,  whitespace: true,  message: '类型不能为空', }, ],  }, ]"
                                    @mouseenter="typeOpt(k,`tag-${k}`)">
                                    <a-select-option :value="item.type" v-for="item in seleListType[k]"
                                                     :key="item.type">
                                        {{ item.type }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </div>
                        <div class="flex">
                            <a-form-item label="分 组" class="inputBox">
                                <a-input-number style="width: 100%" :min="1" :max="999999" :precision="0"
                                                v-decorator="[ `group-${k}`, {   rules: [ { required: true, message: '分组不能为空', }, ],  }, ]"/>
                            </a-form-item>
                            <a-form-item label="css" class="inputBox">
                                <a-input style="width: 100%"
                                         v-decorator="[ `css-${k}`, {   rules: [ { required: true,  whitespace: true,  message: 'css不能为空', }, ],  }, ]"
                                />
                            </a-form-item>
                        </div>
                        <div class="flex" v-show="form.getFieldValue(`type-${k}`)=='img'||form.getFieldValue(`type-${k}`)=='banner'||form.getFieldValue(`type-${k}`)=='bacimg'">
                            <template>
                                <a-form-item label="PC图片" class="inputBox">
                                    <a-input v-decorator="[ `thumb_suggest-${k}`  ]" />
                                </a-form-item>
                                <a-form-item label="移动图片" class="inputBox" v-show="form.getFieldValue(`type-${k}`)=='banner'">
                                    <a-input v-decorator="[ `mobile_thumb_suggest-${k}` ]" />
                                </a-form-item>
                            </template>
                        </div>
                        <div class="inputBox">
                            <a-icon
                                class="dynamic-delete-button"
                                type="minus-circle-o"
                                v-if="keysa.length > 1"
                                @click="() => remove(k)"
                                style="position: absolute;right: 5px;top: calc(50% - 18px)"
                            />
                        </div>
                    </div>
                    <a-form-item v-bind="formItemLayoutWithOutLabel">
                        <a-button type="dashed" style="width: 60%" @click="add">
                            <a-icon type="plus"/>
                            添加模块
                        </a-button>
                    </a-form-item>
                </a-form>
                <div class="drawer-btn" style="position: fixed!important;width: 720px!important;right: 0!important;">
                    <a-button type="primary" @click="submitForm('dynamicValidateForm')" :style="{ marginRight: '8px' }">
                        确定
                    </a-button>
                    <a-button @click="onClose">
                        取消
                    </a-button>
                </div>
            </a-spin>
        </a-drawer>
    </div>
</template>

<script>
import {submitForm, drawerConfig} from "@/utils/utils"
import API from "../api";

let id = 0;
export default {
    name: "indexContent",
    props: ["visible", "title", "editIds"],
    data() {
        return {
            spinning: true,
            drawerConfig,
            keysa: 1,
            ids: "",
            seleList: [],
            seleListType: [],
            ListType: [],
            formItemLayoutWithOutLabel: {
                labelCol: {span: 5},
                wrapperCol: {span: 16},
            },

        };
    },
    beforeCreate() {
        this.form = this.$form.createForm(this, {name: 'dynamic_form_item'});
        // this.form.getFieldDecorator('keys', { initialValue: [], preserve: true });
    },
    watch: {
        editIds: function (a, b) {
            if (a != "") {
                API.service.GETTEMPLATECONTENT(a).then(res => {
                    this.seleList = res.data.data
                    this.seleList.tagList.map((item, index) => {
                        this.ListType[item.tag] = item.tag_type
                    })
                    this.dynamicValidateForm = res.data.data.info
                    this.dynamicValidateForm.id = a
                    let _that = this
                    this.dataJson = res.data.data.info.index_content
                    let jsons = {}
                    let keyId = []
                    this.ids = a
                    this.dataJson.map((item, index) => {
                        jsons[`css-${index}`] = item.css
                        jsons[`group-${index}`] = item.group
                        jsons[`tag-${index}`] = item.tag
                        jsons[`thumb_suggest-${index}`] = item.thumb_suggest
                        jsons[`mobile_thumb_suggest-${index}`] = item.mobile_thumb_suggest
                        jsons[`type-${index}`] = item.type
                        keyId.push(index)
                    })
                    if (this.dataJson.length < 1) {
                        jsons = {
                            "css-0": "",
                            "group-0": "",
                            "tag-0": "",
                            "thumb_suggest-0": "",
                            "mobile_thumb_suggest-0": "",
                            "type-0": "",
                        }
                        keyId.push(0)
                    }
                    this.keysa = keyId
                    this.$nextTick(() => {

                        this.form.setFieldsValue({...jsons});
                        this.$forceUpdate()
                        _that.spinning = false
                          //   setTimeout(()=>{
                          // },1000)
                    })
                    this.$nextTick(() => {
                    })
                })
            }
        }
    },
    mounted() {

    },
    methods: {
        typeOpt(index, tag) {
            // this.seleListType[index]=this.ListType[val]
            if (this.seleListType[index] && this.seleListType[index].length > 0) {

            } else {
                this.seleListType[index] = this.ListType[this.form.getFieldValue(tag)]
                this.$forceUpdate("dynamic_form_item")
            }

        },
        remove(k) {
            const {form} = this;
            this.keysa.map((item, index) => {
                if (item == k) this.keysa.splice(index, 1)
            })
        },
        add() {
            const {form} = this;
            this.keysa.push(this.keysa[this.keysa.length - 1] * 1 + 1)
        },
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                    let formData = []
                    this.keysa.map((item, index) => {
                        formData[index] = {}
                    })
                    for (var item in values) {
                        let num = item.split("-")[1];
                        let val = item.split("-")[0];
                        formData[num][val] = values[item] ? values[item] : ""
                    }
                }
            });
        },
        changeTag(val, index) {
            console.log(this.ListType[val])
            console.log(this.seleListType)
            this.seleListType[index] = this.ListType[val]
            this.form.setFieldsValue({["type-" + (() => index)()]: ""})
            this.$forceUpdate("dynamic_form_item")
        },
        changeType(val, index) {
            this.form.setFieldsValue({["type-" + (() => index)()]: val})
            this.$forceUpdate("dynamic_form_item")
        },
        onClose() {
            this.$emit("changVisible", false);
            // this.dynamicValidateForm= {
            //     id:"",
            //     index_content: [],
            // }
            this.spinning = true
            this.form.resetFields();
            // this.$refs.dynamicValidateForm.resetFields();
        },
        submitForm(formName) {
            let _this = this;
            this.form.validateFields((err, values) => {
                if (!err) {
                    let url
                    url = API.service.GETTEMPLATECONTENTPOST
                    let formData = []
                    this.keysa.map((item, index) => {
                        formData.push({
                            css: values[`css-${item}`],
                            group: values[`group-${item}`],
                            tag: values[`tag-${item}`],
                            thumb_suggest: values[`thumb_suggest-${item}`] ? values[`thumb_suggest-${item}`] : "",
                            mobile_thumb_suggest: values[`mobile_thumb_suggest-${item}`] ? values[`mobile_thumb_suggest-${item}`] : "",
                            type: values[`type-${item}`],
                        })
                    })
                    submitForm(url, {index_content: formData, id: _this.ids}).then(res => {
                        if (res == true) {
                            this.onClose()
                        } else {
                            res.map((item, index) => {
                                this.formErr[item.field] = item.msg
                            })
                        }
                    })
                }
            });
        },
    },
}
</script>

<style scoped>
.dynamic-delete-button {
    cursor: pointer;
    position: relative;
    top: 4px;
    font-size: 24px;
    color: #999;
    transition: all 0.3s;
}

.dynamic-delete-button:hover {
    color: #777;
}

.dynamic-delete-button[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
}

.inputBox {
    width: 50%;
    margin-bottom: 10px
}

.bigBox >>> .ant-form-extra {
    top: calc(100% - 30px) !important;
    position: absolute
}

/*.bigBox >>> .ant-form-explain{position: absolute!important;}*/
</style>
